export default {
  ADD_EXHIBITOR: 'Aussteller hinzufügen',
  NO_EXHIBITOR: 'Sie haben noch keine Aussteller hinzugefügt!',
  EXHIBITOR_NAME: 'Name des Ausstellers',
  EXHIBITOR_EMAIL: 'Aussteller-E-Mail',
  EXHIBITOR_CONTACT: 'Ausstellerkontakt',
  CITY: 'Stadt',
  COUNTRY: 'Land',
  ADDRESS: 'Adresse',
  ORGANISATION: 'Institution',
  TRANSACTION_ID: 'Transaktionsnummer',
  DATE_OF_PURCHASE: 'Kaufdatum',
  DEVICES_COUNT: 'Geräteanzahl',
  ADD_EXHIBITOR_SUCCESS: 'Ihr Ausstellerprofil wurde erfolgreich angelegt!',
  LICENSE_DETAILS: 'Einzelheiten zur Lizenz',
  UPDATE_EXHIBITOR_SUCCESS: 'Ihr Profil wurde erfolgreich gespeichert!',
  EDIT_EXHIBITOR: 'Aussteller bearbeiten'
}
